import React from "react";
import articles from "../../backend/db/articles.json";
import SEO from "../SEO";
import ArticleCard from "./ArticleRouter";
import styles from "./Article.module.css";

const Articles = () => {
  return (
    <div className={styles.articlesSection}>
      <SEO
        title="מאמרים על משתנות ללא מים | מדריכים וטיפים | ווטרלס Waterless"
        description="מאמרים ומדריכים מקצועיים על משתנות ללא מים — יתרונות סביבתיים, חיסכון בעלויות מים, תחזוקה נמוכה, ROI לעסקים והשפעה חיובית על הסביבה. כל מה שצריך לדעת לפני שעוברים למשתנות ללא מים."
        path="/articles"
      />
      <div className="container">
        <div className={styles.articlesHeader}>
          <h1 className={styles.articlesTitle}>
            מאמרים <span className="greenHighlight">ויתרונות</span>
          </h1>
          <p className={styles.articlesSubtitle}>
            כל מה שצריך לדעת על משתנות ללא מים, יתרונותיהן והשפעתן החיובית על הסביבה והעסק שלכם
          </p>
        </div>
        <div className={styles.articlesGrid}>
          {articles.map((article) => (
            <ArticleCard
              key={article.Id}
              title={article.Title}
              route={article.Route}
              introduction={article.Introduction}
              image={article.image}
              publishedDate={article.publishedDate}
              author={article.author}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Articles;
